import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

/**
 * Retired WordPress flip-book viewer URLs. The flip book showed the brochure,
 * so they go to the brochure PDF (Search Console showed 21 impressions for
 * them; old-URL audit, 1 Nov 2026).
 */
export const Route = createFileRoute("/3d-flip-book/$")({
  beforeLoad: ({ location }) => {
    throw redirect({
      href: withQuery("/downloads/RESTORE-Hair-Brochure.pdf", location.searchStr),
      statusCode: 301,
    });
  },
});
